

export default {
  locale: 'ka',
  Pagination: {
    items_per_page: '/ გვერდი.',
    jump_to: 'გადასვლა',
    jump_to_confirm: 'დადასტურება',
    page: '',
    prev_page: 'წინა გვერდი',
    next_page: 'შემდეგი გვერდი',
    prev_5: 'წინა 5 გვერდი',
    next_5: 'შემდეგი 5 გვერდი',
    prev_3: 'წინა 3 გვერდი',
    next_3: 'შემდეგი 3 გვერდი',
    page_size: 'Page Size'
  },
  DatePicker: {
    lang: {
      placeholder: 'აირჩიეთ თარიღი',
      yearPlaceholder: 'აირჩიეთ წელი',
      quarterPlaceholder: 'აირჩიეთ მეოთხედი',
      monthPlaceholder: 'აირჩიეთ თვე',
      weekPlaceholder: 'აირჩიეთ კვირა',
      rangePlaceholder: ['საწყისი თარიღი', 'საბოლოო თარიღი'],
      rangeYearPlaceholder: ['საწყისი წელი', 'საბოლოო წელი'],
      rangeMonthPlaceholder: ['საწყისი თვე', 'საბოლოო თვე'],
      rangeWeekPlaceholder: ['საწყისი კვირა', 'საბოლოო კვირა'],
      locale: 'ka_GE',
      today: 'დღეს',
      now: 'ახლა',
      backToToday: 'მიმდინარე თარიღი',
      ok: 'Ok',
      clear: 'გასუფთავება',
      month: 'თვე',
      year: 'წელი',
      timeSelect: 'დროის არჩევა',
      dateSelect: 'თარიღის არჩევა',
      weekSelect: 'კვირის არჩევა',
      monthSelect: 'თვის არჩევა',
      yearSelect: 'წლის არჩევა',
      decadeSelect: 'ათწლეულის არჩევა',
      yearFormat: 'YYYY',
      dateFormat: 'M/D/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'M/D/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'წინა თვე (PageUp)',
      nextMonth: 'მომდევნო თვე (PageDown)',
      previousYear: 'წინა წელი (Control + left)',
      nextYear: 'მომდევნო წელი (Control + right)',
      previousDecade: 'წინა ათწლეული',
      nextDecade: 'მომდევნო ათწლეული',
      previousCentury: 'გასული საუკუნე',
      nextCentury: 'მომდევნო საუკუნე'
    },
    timePickerLocale: {
      placeholder: 'აირჩიეთ დრო',
      rangePlaceholder: ['საწყისი თარიღი', 'საბოლოო თარიღი']
    }
  },
  TimePicker: {
    placeholder: 'აირჩიეთ დრო',
    rangePlaceholder: ['საწყისი თარიღი', 'საბოლოო თარიღი']
  },
  Calendar: {
    lang: {
      placeholder: 'აირჩიეთ თარიღი',
      yearPlaceholder: 'აირჩიეთ წელი',
      quarterPlaceholder: 'აირჩიეთ მეოთხედი',
      monthPlaceholder: 'აირჩიეთ თვე',
      weekPlaceholder: 'აირჩიეთ კვირა',
      rangePlaceholder: ['საწყისი თარიღი', 'საბოლოო თარიღი'],
      rangeYearPlaceholder: ['საწყისი წელი', 'საბოლოო წელი'],
      rangeMonthPlaceholder: ['საწყისი თვე', 'საბოლოო თვე'],
      rangeWeekPlaceholder: ['საწყისი კვირა', 'საბოლოო კვირა'],
      locale: 'ka_GE',
      today: 'დღეს',
      now: 'ახლა',
      backToToday: 'მიმდინარე თარიღი',
      ok: 'Ok',
      clear: 'გასუფთავება',
      month: 'თვე',
      year: 'წელი',
      timeSelect: 'დროის არჩევა',
      dateSelect: 'თარიღის არჩევა',
      weekSelect: 'კვირის არჩევა',
      monthSelect: 'თვის არჩევა',
      yearSelect: 'წლის არჩევა',
      decadeSelect: 'ათწლეულის არჩევა',
      yearFormat: 'YYYY',
      dateFormat: 'M/D/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'M/D/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'წინა თვე (PageUp)',
      nextMonth: 'მომდევნო თვე (PageDown)',
      previousYear: 'წინა წელი (Control + left)',
      nextYear: 'მომდევნო წელი (Control + right)',
      previousDecade: 'წინა ათწლეული',
      nextDecade: 'მომდევნო ათწლეული',
      previousCentury: 'გასული საუკუნე',
      nextCentury: 'მომდევნო საუკუნე'
    },
    timePickerLocale: {
      placeholder: 'აირჩიეთ დრო',
      rangePlaceholder: ['საწყისი თარიღი', 'საბოლოო თარიღი']
    }
  },
  global: {
    placeholder: 'გთხოვთ აირჩიოთ'
  },
  Table: {
    filterTitle: 'ფილტრის მენიუ',
    filterConfirm: 'კარგი',
    filterReset: 'გასუფთავება',
    filterEmptyText: 'ფილტრები არაა',
    emptyText: 'ინფორმაცია არაა',
    selectAll: 'აირჩიეთ მიმდინარე გვერდი',
    selectInvert: 'შეაბრუნეთ მიმდინარე გვერდი',
    selectionAll: 'ყველას მონიშვნა',
    sortTitle: 'დალაგება',
    expand: 'სტრიქონის გაშლა',
    collapse: 'სტრიქონის შეკუმშვა',
    triggerDesc: 'დაღმავალი დალაგება',
    triggerAsc: 'აღმავალი დალაგება',
    cancelSort: 'დალაგების გაუქმება',
    selectNone: 'მონაცემების გასუფთავება'
  },
  Modal: {
    okText: 'კარგი',
    cancelText: 'გაუქმება',
    justOkText: 'ოკ'
  },
  Popconfirm: {
    okText: 'კარგი',
    cancelText: 'გაუქმება'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'მოძებნე აქ',
    itemUnit: 'ერთეული',
    itemsUnit: 'ერთეულები',
    remove: 'ამოშლა',
    selectCurrent: 'მიმდინარე გვერდის არჩევა',
    removeCurrent: 'მიმდინარე გვერდის ამოშლა',
    selectAll: 'ყველას მონიშვნა',
    removeAll: 'ყველას წაშლა',
    selectInvert: 'მიმდინარე გვერდის შებრუნება'
  },
  Upload: {
    uploading: 'იტვირთება...',
    removeFile: 'ფაილის ამოშლა',
    uploadError: 'ატვირთვის შეცდომა',
    previewFile: 'ფაილის გადახედვა',
    downloadFile: 'ფაილის ჩამოტვირთვა'
  },
  Empty: {
    description: 'ინფორმაცია არაა'
  },
  Icon: {
    icon: 'ხატულა'
  },
  Text: {
    edit: 'რედაქტირება',
    copy: 'ასლი',
    copied: 'ასლი აღებულია',
    expand: 'გაშლა'
  },
  PageHeader: {
    back: 'უკან'
  },
  Image: {
    preview: 'გადახედვა'
  }
};
